/**
 * Build the canonical task-order record id for a pivot/group pair.
 */ export function getTaskOrderId(pivotType, groupId) {
    return `${pivotType}::${groupId}`;
}
